import { inject, observer } from 'mobx-react'
import * as React from 'react'
import PrimaryButton from '../components/PrimaryButton'
import SecondaryButton from '../components/SecondaryButton'
import { IRootStore } from '../models/root'
import Overlay from './Overlay'
import './TopLevelError.scss'

interface ITopLevelErrorProps {}

interface InjectedProps extends ITopLevelErrorProps {
  store: IRootStore
}

@inject('store')
@observer
class TopLevelError extends React.Component<ITopLevelErrorProps> {
  get injected() {
    return this.props as InjectedProps
  }

  public render() {
    const { store } = this.injected

    if (store.topLevelError) {
      return (
        <Overlay
          visible={Boolean(store.topLevelError)}
          closeCallback={this.closeCallback}
        >
          <div className="toplevelerror theme--yellow">
            <img src={require('../img/error.svg')} alt="Sad face emoji"/>
            <h1>Something went wrong!</h1>
            <p>We've been notified about this error and will fix it as soon as possible.</p>
            <div className="toplevelerror__message">
              <h3>Error Message</h3>
              <p>{store.topLevelError.text}</p>
            </div>
            {store.topLevelError.hasFix ? (
              <PrimaryButton text="Try to fix it" callback={store.tryTopLevelErrorFix} />
            ) : (
              <SecondaryButton text="Refresh Page" callback={this.refreshPage} />
              // <p className="toplevelerror__refresh"><small>Refresh to try again</small></p>
            )}
          </div>
        </Overlay>
      )
    }

    return <div />
  }

  private closeCallback = () => {
    const { store } = this.injected

    if (store.topLevelError.hasFix) {
      store.tryTopLevelErrorFix()
    }
  }

  private refreshPage = () => {
    location.reload()
  }
}

export default TopLevelError



// WEBPACK FOOTER //
// ./src/components/TopLevelError.tsx